// extracted by mini-css-extract-plugin
module.exports = {"review":"Kyc_review__Ngc3x"};